export default __webpack_public_path__ + "static/media/42race.278a9fa4.png";